import './AddButton.scss';

const AddButton = (props) => {
    const { onClick } = props;

    return (
        <div className="v2-add-button" onClick={onClick}>
            +
        </div>
    );
}

export default AddButton;
